export default __webpack_public_path__ + "static/media/vire5.41d7c922.jpg";